"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventName = exports.getEventChecked = exports.getEventValue = void 0;
var ramda_1 = require("ramda");
/**
 *  Забирает value из synthetic event;
 */
// tslint:disable:no-any
var getEventValue = function (event) {
    return (0, ramda_1.pathOr)('', ['currentTarget', 'value'], event);
};
exports.getEventValue = getEventValue;
var getEventChecked = function (event) {
    return (0, ramda_1.pathOr)('', ['currentTarget', 'checked'], event);
};
exports.getEventChecked = getEventChecked;
var getEventName = function (event) {
    return (0, ramda_1.pathOr)('', ['currentTarget', 'name'], event);
};
exports.getEventName = getEventName;
//# sourceMappingURL=getEventValue.js.map